import purchaseOrderActions, { purchaseOrderActionTypes } from '../actions/purchaseOrderActions';

const PurchaseOrderReducers = (state = { }, action) => {
  switch (action.type) {
  case purchaseOrderActionTypes.GET_DOWNLOAD_PURCHASE_ORDER_DATA.LOADING: {
    const { getDownloadPOLoading } = action;
    return {
      ...state,
      getDownloadPOLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PURCHASE_ORDERS.LOADING: {
    const { getPurchaseOrdersLoading } = action;
    return {
      ...state,
      getPurchaseOrdersLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PURCHASE_ORDERS.SUCCESS: {
    const { purchaseOrders } = action;
    return {
      ...state,
      purchaseOrders,
    };
  }
  case purchaseOrderActionTypes.CREATE_PURCHASE_ORDER.LOADING: {
    const { createPurchaseOrderLoading } = action;
    return {
      ...state,
      createPurchaseOrderLoading,
    };
  }
  case purchaseOrderActionTypes.APPROVE_PO.LOADING: {
    const { approvePOLoading } = action;
    if (action.poType === 'APPROVED') {
      return {
        ...state,
        approveApprovePOLoading: approvePOLoading,
      };
    }
    return {
      ...state,
      approveRejectPOLoading: approvePOLoading,
    };
  }
  case purchaseOrderActionTypes.UPDATE_PURCHASE_ORDER.LOADING: {
    const { updatePurchaseOrderLoading } = action;
    return {
      ...state,
      updatePurchaseOrderLoading,
    };
  }
  case purchaseOrderActionTypes.UPDATE_PO_EXPIRY_DATE.LOADING: {
    const { updatePurchaseOrderExpiryDateLoading } = action;
    return {
      ...state,
      updatePurchaseOrderExpiryDateLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PO_ANALYTICS.LOADING: {
    const { getPOAnalyticsLoading } = action;
    return {
      ...state,
      getPOAnalyticsLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PO_ANALYTICS.SUCCESS: {
    const { purchaseAnalyticsData } = action;
    return {
      ...state,
      purchaseAnalyticsData,
    };
  }
  case purchaseOrderActionTypes.GET_PO_PENDING_APPROVAL.LOADING: {
    const { getPoPendingApprovalLoading } = action;
    return {
      ...state,
      getPoPendingApprovalLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PO_PENDING_APPROVAL.SUCCESS: {
    const { pendingPos } = action;
    return {
      ...state,
      pendingPos,
    };
  }
  case purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.LOADING: {
    const { getPurchaseOrderByIdLoading } = action;
    return {
      ...state,
      getPurchaseOrderByIdLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.SUCCESS: {
    const { selectedPurchaseOrder } = action;
    return {
      ...state,
      selectedPurchaseOrder,
    };
  }
  case purchaseOrderActionTypes.GET_PO_SEQUENCE.LOADING: {
    const { getPoSequenceLoading } = action;
    return {
      ...state,
      getPoSequenceLoading,
    };
  }
  case purchaseOrderActionTypes.GET_PO_SEQUENCE.SUCCESS: {
    const { poSequence } = action;
    return {
      ...state,
      poSequence,
    };
  }
  case purchaseOrderActionTypes.UPDATE_PO_STATUS.LOADING: {
    const { updatePoStatusLoading } = action;
    return {
      ...state,
      updatePoStatusLoading,
    };
  }
  case purchaseOrderActionTypes.UPDATE_PO_WORKFLOW_STEP.LOADING: {
    const { updatePoWorkflowStepLoading } = action;
    return {
      ...state,
      updatePoWorkflowStepLoading,
    };
  }
  case purchaseOrderActionTypes.DELETE_PURCHASE_ORDER.LOADING: {
    const { deletePurchaseOrderLoading } = action;
    return {
      ...state,
      deletePurchaseOrderLoading,
    };
  }
  case purchaseOrderActionTypes.UPDATE_PO_SEQUENCE.LOADING: {
    const { updatePoSequenceLoading } = action;
    return {
      ...state,
      updatePoSequenceLoading,
    };
  }
  case purchaseOrderActionTypes.SEND_PO_EMAIL_TO_VENDOR.LOADING: {
    const { sendPOMailToVendorLoading } = action;
    return {
      ...state,
      sendPOMailToVendorLoading,
    };
  }
  case purchaseOrderActionTypes.CLOSE_PO.LOADING: {
    const { closePoLoading } = action;
    return {
      ...state,
      closePoLoading,
    };
  }
  case purchaseOrderActionTypes.SEND_PO_WHATSAPP.LOADING: {
    const { sendPoWhatsappLoading } = action;
    return {
      ...state,
      sendPoWhatsappLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default PurchaseOrderReducers;
